export const CREATE_SHIPPING_LABEL_EXCLUDED_ORGS = [2096, 595, 2002]
